export function validateQuery(selector: string) {
  try {
    document.querySelector(selector)
    return true
  } catch (e) {
    console.log("Error occurred while validating query:", e)
  }
  return false
}

/**
 * @example import {addGlobalEventListener} from "./utils"
 * addGlobalEventListener("click", ".i-usp", (clickedElement) => {
 *  console.log(clickedElement)
 * })
 */
export function addGlobalEventListener(
  type: string,
  selector: string,
  callback: (clickedElement: Element, event: Event) => void,
  parent: Document | Element = document,
) {
  parent.addEventListener(type, (event) => {
    const target = event.target

    if (target instanceof Element && target.closest(selector)) {
      const clickedElement = target.closest(selector)
      if (clickedElement) {
        callback(clickedElement, event)
      }
    }
  })
}

export const debounce = <F extends (...args: Parameters<F>) => ReturnType<F>>(fn: F, delay: number = 500) => {
  let timeout: ReturnType<typeof setTimeout>
  return (...args: Parameters<F>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export function hashCode(str: string) {
  return str.split("").reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
}
